<template>
    <kendo-tooltip :title="text" :position="'top'">
        <b-btn :variant="variant" @click="$emit('click')" :disabled="disabled">
            <span :class="icon"></span>
        </b-btn>
    </kendo-tooltip>
</template>

<script>
export default {
  props: {
    variant: { type: String, default: 'outline-primary icon-btn' },
    icon: { type: String },
    text: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  }
}
</script>
